"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGToggle = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Toggle.scss");

var BHGToggle = function BHGToggle(props) {
  var active = props.active,
      handleClick = props.handleClick,
      disabled = props.disabled;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "BHG-toggle " + (active ? "active" : "") + (disabled ? " disabled" : ""),
    onClick: disabled ? function () {
      return null;
    } : handleClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slider"
  }));
};

exports.BHGToggle = BHGToggle;
BHGToggle.defaultProps = {
  active: false,
  disabled: false,
  handleClick: null
};